var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKipSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M384 256C384 260.406 380.406 264 376 264H117.373L349.25 465.969C352.594 468.875 352.938 473.937 350.031 477.25C348.438 479.062 346.219 480 344 480C342.125 480 340.25 479.344 338.75 478.031L104 273.572V472C104 476.406 100.406 480 96 480S88 476.406 88 472V264H8C3.594 264 0 260.406 0 256S3.594 248 8 248H88V40C88 35.594 91.594 32 96 32S104 35.594 104 40V238.428L338.75 33.969C342.031 31.094 347.094 31.406 350.031 34.75C352.938 38.062 352.594 43.125 349.25 46.031L117.373 248H376C380.406 248 384 251.594 384 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKipSign);
export default __webpack_public_path__ + "static/media/kip-sign.7ef6970138e06e3575ecc548c7a3d6dd.svg";
export { ForwardRef as ReactComponent };